import googleMapsService from '../services/googleMapsService';

export const deadlineToTimestamp = (time, now = Date.now()) => {
  if (!/^\d{2}:\d{2}$/.test(time || '')) return null;
  const [hours, minutes] = time.split(':').map(Number);
  const deadline = new Date(now);
  deadline.setHours(hours, minutes, 0, 0);
  return deadline.getTime() > now ? deadline.getTime() : null;
};

export const getScheduleInfo = (place, origin, plan, now = Date.now()) => {
  const restaurant = place?.geometry?.location;
  if (!restaurant || !origin || !plan?.destination || !plan.deadline) return null;
  const distanceTo = googleMapsService.calculateDistance(origin, restaurant);
  const distanceOn = googleMapsService.calculateDistance(restaurant, plan.destination);
  if (distanceTo == null || distanceOn == null) return null;
  const walkTo = Math.max(1, Math.round(distanceTo / 80));
  const walkOn = Math.max(1, Math.round(distanceOn / 80));
  const requiredMinutes = walkTo + walkOn + (plan.mealMinutes || 45) + 10;
  const availableMinutes = Math.floor((plan.deadline - now) / 60000);
  const slackMinutes = availableMinutes - requiredMinutes;
  return {
    walkTo, walkOn, requiredMinutes, slackMinutes,
    status: slackMinutes >= 15 ? 'safe' : slackMinutes >= 0 ? 'tight' : 'late'
  };
};
